import styled from 'styled-components'

const MoreQuestionsButtonContainer = styled.span`
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-anchor: none;
`

const MoreQuestionsButtonText = styled.span`
  text-align: center;
  height: 14px;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${props => props.theme.color.monochrome.dark};
`

const ProgressBarContainer = styled.span`
  width: 186px;
`

export { MoreQuestionsButtonContainer, MoreQuestionsButtonText, ProgressBarContainer }
